let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5x1Zd")).then(() => parcelRequire('eA4kS'));